module.exports = __webpack_public_path__ + "media/images/career_camp/2023/right-paddle-625e470d870d66fd07c50e5e077b830d.svg";